import { BASE_URL_SETTING } from '../routes.constants'
import type { Route } from '~/interfaces/routes.interfaces'
import { TAB_FINANCIAL_ENTITY_INDICATOR } from '~/constants/tab/financial-entity/tab.constants'

const base = `${BASE_URL_SETTING}/financial-entity`

export const SETTINGS_FINANCIAL_ENTITY: Route = {
  path: base
}

export const SETTINGS_FINANCIAL_ENTITY_CREATE: Route = {
  path: `${base}/create`
}

export const SETTINGS_FINANCIAL_ENTITY_EDIT: Route = {
  path: `${base}/{id}`
}

export const SETTINGS_FINANCIAL_ENTITY_EDIT_TAB_INDEX_INDICATOR: Route = {
  path: `${base}/{id}?tab=${TAB_FINANCIAL_ENTITY_INDICATOR}`
}
